import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Option } from './options';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss', '../input/input.component.scss'],
})
export class SelectComponent implements OnChanges {
  @Input() public disabled: boolean = false;
  @Input() public fc: UntypedFormControl;
  @Input() public label: string;
  @Input() public options: Option[];
  @Input() public emptyOption = true;
  @Input() public note: string;

  ngOnChanges({ disabled }: SimpleChanges): void {
    if (disabled) {
      if (disabled.currentValue) {
        this.fc?.disable();
      } else if (this.fc?.disabled) {
        this.fc?.enable();
      }
    }
  }
}
